<template>
  <div>
    <a-dropdown v-if="permission" :trigger="['click']">
      <span class="edit-review">
        <a-tag :color="storyReviews[value].color">{{ storyReviews[value].label }}</a-tag>
        <a-icon class="icon-down" type="down" />
      </span>
      <a-menu slot="overlay">
        <a-menu-item v-for="(item, key) in storyReviews" :key="key" @click="onChange(item.value)">
          <a-tag :color="item.color">{{ item.label }}</a-tag>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <span v-else>
      <a-tag :color="storyReviews[value].color">{{ storyReviews[value].label }}</a-tag>
    </span>
  </div>
</template>
<script>
import { storyUpdateItem } from '@/api/project/story';
import { permissionRequired } from '@/utils/utils';
import { storyReviews } from '@/utils/dictionary';

export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    storyId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      storyReviews,
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  computed: {
    permission() {
      return permissionRequired('project:requirement:edit', this.projectId);
    }
  },
  methods: {
    onChange(value) {
      storyUpdateItem({
        project_id: this.projectId,
        requirement_id: this.storyId,
        key: 'is_review',
        value: value
      }).then(() => {
        this.isEdit = false;
        this.$message.success('更新成功');
        this.$emit('change');
      });
    }
  }
};
</script>

<style lang="less" scoped>
.edit-review {
  cursor: pointer;
  display: inline-block;
  padding: 0 2px;
  line-height: 22px;
  .icon-down {
    opacity: 0;
  }
}
.edit-review:hover {
  cursor: pointer;
  background-color: #e4e4e4;
  .icon-down {
    opacity: 1;
  }
}
/deep/.ant-tag {
  margin-right: 0;
}
</style>
